export enum TypeFieldGrievanceNotificationEnum {
    select = 1,
    text = 2,
    date = 3,
    number = 4,
    checkbox = 5, 
    toggle = 6,
    multiselect = 7
}